import {MenuItemActionBase} from "../menu-item-action-base";
import {IMenuItemExecuteOptions} from "../menu-item-action.interface";
import {IMenuItemConfigReader} from "../../menu-items-common/menu-item-config-reader/menu-item-config-reader.interface";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";

/**
 * This class is for demonstrating how to override menu items per regulation. It should be removed when we will have a real case
 */
export default class TestRegulationSpecificAction extends MenuItemActionBase {
    constructor(configReader: IMenuItemConfigReader, services: IServiceFactoryExtended) {
        super("testRegulationSpecificMenuItem", configReader, services);
    }
    protected async _onClick(options?: IMenuItemExecuteOptions): Promise<void> {
        this.services.dialog.showSimpleTextModal({
            text: 'Test regulation specific menu item',
            title: 'test',
        });
    }
}